import { render, staticRenderFns } from "./UpdatePhoneDialog.vue?vue&type=template&id=307d1f13"
import script from "./UpdatePhoneDialog.vue?vue&type=script&lang=js"
export * from "./UpdatePhoneDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports